 
import React from 'react';
import {Header, Breadcrumb, Container,Loader, Rating, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio, Checkbox, Popup, Icon, Segment} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import Tabla from "../common/ManageTabla";
import CurrencyInput from 'react-currency-input-field';
import { DatePicker, Space } from 'antd';
//import "antd/dist/antd.css";
import dayjs from 'dayjs';
import locale from 'antd/es/date-picker/locale/es_ES';
import moment from 'moment';
const dateFormat = 'DD/MM/YYYY';

const CursoForm=({ id, color, form, usuarioCombo, tagCombo, cursoCombo, onSave,
                  headersTablaModulos, camposTablaModulos, moduloCombo, 
                  validacionesTablaModulos, onChange, archivos, onChangeCurrency, verModulo, 
                  tipoTablaModulos, ajaxCallInProgress, datos,cursoTipoCombo, strings, permisos, fechas, onBuscar, errors={}})=>{
    
    
	return (
        <Container>
          <Dimmer active={ajaxCallInProgress>0?true:false} inverted>
          		<Loader size='big' inline content={strings?strings["Procesando"]:""}/>
          </Dimmer>

			
			<Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form  >          
                            <Form.Field  required  error={errors.titulo}>            
                              <label  >{strings?strings["titulo"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["titulo"]:""} 
                                    name="titulo"
                                    onChange={onChange}
                                    value={datos.titulo}
                                    icon='edit'/>
                            </Form.Field>
                            
                            <Form.Field  required  error={errors.cursoTipoId}>
                              <label  >{strings?strings["cursoTipoId"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["cursoTipoId"]:""} 
                                    name="cursoTipoId"
									 fluid 
                                    search 
                                    selection
                                    onChange={onChange}
                                    value={datos.cursoTipoId}
                                    options={cursoTipoCombo}/>
                            </Form.Field>
        
                            <Form.Field  required  error={errors.costo}>            
                              <label  >{strings?strings["costo"]:""}</label>
                              <CurrencyInput
                                  id="costo"
                                  name="costo"
                                    prefix="$"
                                  placeholder={strings?strings["costo"]:""} 

                                  decimalsLimit={2}
                                    value={datos.costo}
                                  onValueChange={(value, name) => onChangeCurrency(value, name)}
                                />
                            </Form.Field>
                                
                            <Form.Field  required  error={errors.cantidadModulos}>            
                              <label  >{strings?strings["cantidadModulos"]:""}</label>
                              <Input
                                  name="cantidadModulos"
                                  placeholder={strings?strings["cantidadModulos"]:""} 
                                  value={datos.cantidadModulos}
                                  onChange={onChange}
                                />
                            </Form.Field>
                                
                            <Form.Field  required  error={errors.horasTotales}>            
                              <label  >{strings?strings["horasTotales"]:""}</label>
                              <Input
                                  name="horasTotales"
                                  placeholder={strings?strings["horasTotales"]:""} 
                                  value={datos.horasTotales}
                                  onChange={onChange}
                                />
                            </Form.Field>
                                

                            <Form.Field required>
                                <label  >{strings?strings["fechaInicioCurso"]:""}</label>  
                                <DatePicker bordered={false}
                                        value={dayjs(datos.fechaInicio, dateFormat)}
                                        onChange={(dates, dateStrings)=>fechas(dates, dateStrings)} 
                                        locale={locale} 
                                        size="large"
                                        format={dateFormat} />
                                        
                                        
                            
                            </Form.Field>    
                                
                            
                            <Form.Field  required  error={errors.constanciaAutomatica}>
                              <label  >{strings?strings["constanciaAutomatica"]:""}</label>
                                    <Checkbox 
                                        slider 
                                        name="constanciaAutomatica"
                                        size="mini" 
                                        checked={datos.constanciaAutomatica==1? true:false}  
                                        onClick={onChange} 
                                        />
        
        
                
                            </Form.Field>


                            {datos.constanciaAutomatica?
                                <>
                                 <Form.Field  required  error={errors.numeroActividades}>            
                                      <label  >{strings?strings["numeroActividades"]:""}</label>
                                      <Input
                                          name="numeroActividades"
                                          placeholder={strings?strings["numeroActividades"]:""} 
                                          value={datos.numeroActividades}
                                          onChange={onChange}
                                        />
                                    </Form.Field>
                                        
                                    <Form.Field  required  error={errors.avanceVideosMinimo}>            
                                      <label  >{strings?strings["avanceVideosMinimo"]:""}</label>
                                      <Input
                                          name="avanceVideosMinimo"
                                          placeholder={strings?strings["avanceVideosMinimo"]:""} 
                                          value={datos.avanceVideosMinimo}
                                          onChange={onChange}
                                        />
                                    </Form.Field>    
                                 </>       
                                  
                                
                                :
                                ""
                                
                            }
                                        


                            <Form.Field  required  error={errors.descripcionCorta}>            
                              <label  >{strings?strings["descripcionCorta"]:""}</label>
                              <TextArea 
                                    placeholder={strings?strings["descripcionCorta"]:""} 
                                    name="descripcionCorta"
                                    onChange={onChange}
                                    value={datos.descripcionCorta}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.descripcionLarga}>            
                              <label  >{strings?strings["descripcionLarga"]:""}</label>
                              <TextArea 
                                    placeholder={strings?strings["descripcionLarga"]:""} 
                                    name="descripcionLarga"
                                    onChange={onChange}
                                    value={datos.descripcionLarga}
                                    icon='edit'/>
                            </Form.Field>
                                    
                                    
                             <Form.Field  required  error={errors.avancePermitido}>
                              <label  >{strings?strings["permitirAvanceVideo"]:""}</label>
                                    <Checkbox 
                                        slider 
                                        name="avancePermitido"
                                        size="mini" 
                                        checked={datos.avancePermitido==1? true:false}  
                                        onClick={onChange} 
                                        />
        
        
                
                            </Form.Field>        
                            
                            <Form.Field  required  error={errors.idsInstructores}>
                              <label  >{strings?strings["idsInstructores"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["idsInstructores"]:""} 
                                    name="idsInstructores"
									 fluid 
                                    search 
                                    selection
                                    multiple
                                    onChange={onChange}
                                    value={datos.idsInstructores}
                                    options={usuarioCombo}/>
                            </Form.Field>        
                                            
                          
                            <Form.Field  required  error={errors.idsCursosSimilares}>
                              <label  >{strings?strings["idsCursosSimilares"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["idsCursosSimilares"]:""} 
                                    name="idsCursosSimilares"
									 fluid 
                                    search 
                                    selection
                                    multiple
                                    onChange={onChange}
                                    value={datos.idsCursosSimilares}
                                    options={cursoCombo}/>
                            </Form.Field>
                                    
                                    
                              <Form.Field  required  error={errors.idsTags}>
                              <label  >{strings?strings["idsTags"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["idsTags"]:""} 
                                    name="idsTags"
									 fluid 
                                    search 
                                    selection
                                    multiple
                                    onChange={onChange}
                                    value={datos.idsTags}
                                    options={tagCombo.length>0?tagCombo:[]}/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.idsCursosPreviosOpcinales}>
                              <label  >{strings?strings["idsCursosPreviosOpcinales"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["idsCursosPreviosOpcinales"]:""} 
                                    name="idsCursosPreviosOpcinales"
									 fluid 
                                    search 
                                    selection
                                    multiple
                                    onChange={onChange}
                                    value={datos.idsCursosPreviosOpcinales}
                                    options={cursoCombo}/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.idsCursosPreviosObligatorios}>
                              <label  >{strings?strings["idsCursosPreviosObligatorios"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["idsCursosPreviosObligatorios"]:""} 
                                    name="idsCursosPreviosObligatorios"
									 fluid 
                                    search 
                                    selection
                                    multiple
                                    onChange={onChange}
                                    value={datos.idsCursosPreviosObligatorios}
                                    options={cursoCombo}/>
                            </Form.Field>        
                                                                        
                            <Divider hidden/>
							  <Grid centered>
                            <Button.Group  >
                                <Link to="/cursoscatn">
                                    <Button  
										>{strings?strings["regresar"]:""}</Button>
                                </Link>
                                <Button.Or text=" "></Button.Or>
                                <Button  color="black"
                                    onClick={onSave}>{strings?strings["guardar"]:""}
								 </Button>
                              </Button.Group>
                            </Grid>
                           <br/>
                        </Form>
                    </Grid.Column>
                </Grid.Row>
                
            
            </Grid>
        
        </Container>
	);
};



export default CursoForm;